export const fieldsInfo: any = {
  // fields with full cell size (field_map)
  fullSizeFields: [
    'hazardousMaterialDescription',
    'whmisCode',
    'whmisFreeText',
    'hazardousPlacardNotation',
    'textMessage',
  ],
};
